import React from 'react';

export default function KARebuildProgress({ status }) {
  if (!status) return null;
  const running = Boolean(status.manual_rebuild_version);
  const build = running ? status.build_progress : null;
  if (!running && !status.last_rebuild_at) return null;
  const total = Number(build?.total || 0);
  const completed = Number(build?.completed || 0);
  const percent = total > 0 ? Math.min(100, Math.floor(completed / total * 100)) : null;
  const phase = !status.enabled ? '已暂停' : status.error ? '任务中断' : build ? '汇总历史快照' : status.phase === 'backfill' ? '读取历史工单' : '准备重新汇总';
  return <section className="ka-rebuild-progress" aria-label="汇总进度" aria-live="polite">
    <div className="ka-section-heading"><strong>{running ? phase : '上次汇总完成'}</strong><span className="ka-muted">{running ? '每 30 秒自动刷新' : new Date(status.last_rebuild_at).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' })}</span></div>
    {running && (build ? <>
      <div className="ka-rebuild-count"><span>{completed.toLocaleString()} / {total.toLocaleString()} 张工单</span><strong>{percent == null ? '处理中' : `${percent}%`}</strong></div>
      <progress aria-label="重新汇总完成进度" value={completed} max={Math.max(total, 1)} />
      <p className="ka-muted">汇总完成并发布后，看板更新为新版本。</p>
    </> : <p className="ka-muted">{status.phase === 'backfill' ? `已读取 ${Number(status.processed_issues || 0).toLocaleString()} 条工单${status.bootstrap_month ? ` · 回填月份 ${status.bootstrap_month.slice(0, 7)}` : ''}。读取完成后显示汇总进度。` : !status.enabled ? '同步已停用，重新启用后继续已手动提交的任务。' : status.error ? '任务已保留断点，错误原因见下方。' : '手动任务已提交，正在准备数据。'}</p>)}
    {running && status.error && <p className="ka-error">{status.error}</p>}
  </section>;
}
